import gql from 'graphql-tag';

export const TenantExperienceUrl = gql`
	query confluenceEditionAwarenessQuery(
		$cloudId: ID!
		$productKey: String!
		$trialOfferingName: String!
	) {
		tenantContexts(cloudIds: [$cloudId])
			@optIn(to: ["CcpAllUserUpgradeAndPay", "HamsAllUserUpgradeAndPay"]) {
			entitlementInfo(hamsProductKey: $productKey) {
				paidEntitlement: entitlement(where: { inTrialOrPreDunning: false }) {
					experienceCapabilities {
						changeOfferingV2(offeringName: $trialOfferingName) {
							experienceUrl
						}
					}
				}
			}
		}
	}
`;
